const METRIC_CONFIG = {
    opened: {
        percentageKey: 'openedPercentage',
        valueKey: 'opened',
    },
    confirmed: {
        percentageKey: 'confirmedPercentage',
        valueKey: 'confirmed',
    },
};

const toFiniteNumber = (value) => {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const getBillboardPercentage = (model, type) => {
    const config = METRIC_CONFIG[type];
    if (!config) return 0;

    const rawPercentage = toFiniteNumber(model?.[config.percentageKey]);
    if (rawPercentage !== null) {
        return Math.min(Math.max(rawPercentage, 0), 100);
    }

    const sent = toFiniteNumber(model?.sent);
    const metricValue = toFiniteNumber(model?.[config.valueKey]);

    if (sent === null || sent <= 0 || metricValue === null || metricValue <= 0) {
        return 0;
    }

    return Math.min((metricValue * 100) / sent, 100);
};

export const getBillboardPercentageLabel = (model, type) =>
    `${getBillboardPercentage(model, type).toFixed(0)}%`;
